import * as C from "@components";
import React from "react";
import VadImage from "vadimages-nextjs-image-optimizer";
import {altFromHtml} from "@/helpers/alt";

export const ProductBigSectionKeys = [
    "big.headline",
    "big.subhead",
] as const;

interface ProductBigSectionProps extends Omit<C.SideBySideTextProps<typeof ProductBigSectionKeys>, "keys">
{
    pageSectionClassName?: string;
    imageDirectory: string;
    imageProps: Partial<React.ComponentProps<typeof VadImage>>;
    productSlug: string;
}

export const ProductBigSection = ({ imageDirectory, imageProps, layout, productSlug, pageSectionClassName, items, ...props }: ProductBigSectionProps): React.FunctionComponentElement<ProductBigSectionProps> =>
{
    const defaultLayout: C.MediaSpecific<C.SideBySideTextLayout> = { all: { margins: { bottom: C.Margin.D20 } }, ipad: { margins: { bottom: C.Margin.D60 } } };

    const appliedLayout = C.mediaSpecificMerge(layout, "margins", defaultLayout, "margins");

    return (
        <C.PageSection className={pageSectionClassName}>
            <C.SideBySideText keys={ProductBigSectionKeys} 
                items={{ 
                    "big.headline": items?.["big.headline"],
                    "big.subhead": { margins: { left: C.Dimension.Auto, right: C.Dimension.Auto }, ...items?.["big.subhead"]}, 
                }} 
                {...props}
                layout={appliedLayout}
            />
            <C.Card>
                <VadImage src={`${imageDirectory}/big.png`} alt={altFromHtml(props.pageContent["big.headline"]?.data)}  {...imageProps}/>
            </C.Card>
        </C.PageSection>
    );
}